import { render, staticRenderFns } from "./BurgerButton.vue?vue&type=template&id=5311a100&scoped=true&"
var script = {}
import style0 from "./BurgerButton.vue?vue&type=style&index=0&id=5311a100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5311a100",
  null
  
)

export default component.exports